import { RequestActionTypes } from './request.types'

//Add Request
export const creatRequestReq = data => ({
    type: RequestActionTypes.CREATE_REQUEST_REQ,
    payload: data
})

export const creatRequestReqSuccess = data => ({
    type: RequestActionTypes.CREATE_REQUEST_REQ_SUCCESS,
    payload: data
})

export const creatRequestReqError = data => ({
    type: RequestActionTypes.CREATE_REQUEST_REQ_ERROR,
    payload: data
})

export const creatRequestReqStatus = data => ({
    type: RequestActionTypes.CREATE_REQUEST_REQ_STATUS,
    payload: data
})

//Update Request
export const updateRequestStatusReq = data => ({
    type: RequestActionTypes.UPDATE_REQUEST_STATUS_REQ,
    payload: data
})

export const updateRequestStatusReqSuccess = data => ({
    type: RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_SUCCESS,
    payload: data
})

export const updateRequestStatusReqError = data => ({
    type: RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_ERROR,
    payload: data
})

export const updateRequestStatusReStatus = data => ({
    type: RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_STATUS,
    payload: data
})

//Request Detail
export const requestDetailReq = data => ({
    type: RequestActionTypes.REQUEST_DETAIL_REQ,
    payload: data
})

export const requestDetailReqSuccess = data => ({
    type: RequestActionTypes.REQUEST_DETAIL_REQ_SUCCESS,
    payload: data
})

export const requestDetailReqError = data => ({
    type: RequestActionTypes.REQUEST_DETAIL_REQ_ERROR,
    payload: data
})

//Request List
export const requestListReq = data => ({
    type: RequestActionTypes.REQUEST_LIST_REQ,
    payload: data
})

export const requestListReqSuccess = data => ({
    type: RequestActionTypes.REQUEST_LIST_REQ_SUCCESS,
    payload: data
})

export const requestListReqError = data => ({
    type: RequestActionTypes.REQUEST_LIST_REQ_ERROR,
    payload: data
})